@if (config) {
  <agm-map
    [latitude]="config?.lat"
    [longitude]="config?.lng"
    [zoom]="config?.zoom"
    [disableDefaultUI]="false"
    [fitBounds]="config?.fitBounds"
    [scrollwheel]="null"
    [mapTypeId]="mapTypeId"
    [styles]="config?.styles"
    [tilt]="config?.mapTypeId === 'hybrid3d' ? 45 : 0"
    (zoomChange)="onZoomChange($event)"
    (mapReady)="onMapReady($event)"
    (boundsChange)="onBoundsChange($event)"
  >
    <ng-container #vc></ng-container>
  </agm-map>
}
